<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import IRCaseMaintenanceForm from "../../../components/industrialrelations/ircasemaintenance/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": IRCaseMaintenanceForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('ircasemaintenance.newircasemaintenance'),
      pageTitleValue: "",
      formData: {
        recorddate: new Date().toISOString().slice(0,10),
        incidentdate: null,
        caseid: null,
        shortdesc: null,
        longdesc: null,
        incidentcatid: null,
        incidentcatcode: null,
        reportedbyid: null,
        reportedbycode: null,
        remarks: null,
        casestatusid: 1,
        statusremarks: null,
        attach: null,
        attachname: null,
        attachdesc: null,
        documents: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },


      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/ircasemaintenance/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "ircasemaintenancelist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    cancelHandler() {
      this.$router.push({ name: "ircasemaintenancelist" });
    },
  },
};
</script>